import { TIMEFRAME } from '../config/common.config';
import { ReferralLevel, RewardType } from '../enums/project.enum';

export const defaultProjectInput = {
  name: '',
  info: {
    url: '',
    nodeSaleUrl: '',
    description: '',
    whitepaperUrl: '',
    termOfService: '',
    privacyPolicy: '',
    gAnalyticId: '',
    network: {
      telegram: '',
      x: '',
      discord: '',
      youtube: '',
      facebook: '',
      reddit: '',
    },
    isCustomDomain: false,
  },
  node: { name: '', symbol: '', description: '' },
  faqs: [],
  recipients: [{ name: '', address: '' }],
  referral: {
    isEnable: true,
    percentage: 0,
    referLv1: 0,
    referLv2: 0,
    rewardType: RewardType.ERC_20,
    referralLv: ReferralLevel.LEVEL_2,
    isEnableDiscountAll: true,
    isEnableDonation: false,
    isEnableDiscount: false,
    isEnableDiscountKol: false,
    rewardDescription: '',
    rewardLv: [{ node: 0 }, { node: 0 }],
  },
  kols: [],
  setting: {
    defaultToken: undefined,
  },
  tier: {
    autoAdjustment: true,
  },
  royalties: [{ percent: undefined, address: '' }],
  threshold: {
    threshold: 0,
    timeframe: Number(TIMEFRAME),
  },
  nodeSystem: {
    isDatagramEnabled: false,
    email: '',
  },
};
